module.exports = __webpack_public_path__ + "static/media/bleu.86a9eb93.jpg";